import { apiGet, apiPost } from './client';

/** An account made from the MyStateMLS button (gateway routes/partner-launch.ts). */
export interface LaunchAccountState {
  launched: boolean;
  partner: string | null;
  /** The member has chosen a password, so they can also sign in at breadlist.site. */
  claimed: boolean;
  /** What the MyStateMLS roster said at sign-up — the setup wizard starts from it. */
  member?: LaunchMember | null;
  /** Setup not finished yet: /build opens on the welcome step (look + photo). */
  needs_setup?: boolean;
}

export interface LaunchMember {
  full_name?: string;
  first_name?: string;
  last_name?: string;
  office_name?: string;
  office_city?: string;
  office_state?: string;
}

export async function getLaunchAccount(): Promise<LaunchAccountState> {
  return apiGet<LaunchAccountState>('/launch/account');
}

/** Email the member a code to choose a password (the same code email as a password reset). */
export async function sendClaimEmail(): Promise<{ sent: boolean; email: string }> {
  return apiPost<{ sent: boolean; email: string }>('/launch/claim-email');
}
